import React from 'react';
import Slider from "react-slick";
import { Poetry } from 'api/poetryClub';
import { useScreenSize } from 'common';

interface PoetryDetailsProps {
    poetryItem: Poetry;
    title: string;
}

export const PoetryImagesCarousel: React.FC<PoetryDetailsProps> = ({ poetryItem, title }) => {
    const { isDesktopSize } = useScreenSize();
    const hasManyImages = poetryItem.images.length > 1;

    const settings = {
        dots: hasManyImages,
        infinite: hasManyImages,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        autoplay: hasManyImages,
        autoplaySpeed: 2000
    };

    return (
        <div style={{ margin: isDesktopSize ? '0 50px 50px 10px' : '0px 20px 40px' }}>
            <Slider {...settings}>
                {poetryItem.images.map((image, index) => (
                    <div key={index}>
                        {/* Афиши бывают вертикальными — ограничиваем высоту, не обрезая изображение */}
                        <img
                            src={image.photo}
                            alt={`${title} — ${index + 1}`}
                            style={{
                                display: 'block',
                                width: 'auto',
                                height: 'auto',
                                maxWidth: '100%',
                                maxHeight: 500,
                                margin: '0 auto'
                            }}
                        />
                    </div>
                ))}
            </Slider>
        </div>
    );
};
